// This script scrolls to the element with the hash in the URL, and removes the data-aos attribute from it or its parent.

// Handle hash scrolling
function handleHashScroll() {
    if (window.location.hash) {
        console.cclog("[Anchor Scroll Debug] Hash exists: ", window.location.hash);

        // Set scroll restoration to manual to maintain hash location on refresh
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }

        var element = document.querySelector(window.location.hash);
        if (element) {
            // Remove data-aos from the target element if it exists
            if (element.getAttribute('data-aos')) {
                element.removeAttribute('data-aos');
                console.cclog("[Anchor Scroll Debug] Removed data-aos from target element");
            }
            
            // Remove data-aos from the parent element if it exists
            if (element.parentElement.getAttribute('data-aos')) {
                element.parentElement.removeAttribute('data-aos');
                console.cclog("[Anchor Scroll Debug] Removed data-aos from parent element");
            }

            // Handle copy-tab elements
            if (element.classList.contains('tab-pane')) {
                const tabId = element.getAttribute('aria-labelledby');
                const tabButton = document.getElementById(tabId);
                if (tabButton) {
                    tabButton.click();
                    console.cclog("[Anchor Scroll Debug] Clicked tab button for tab-pane");
                }
            }
            
            // Handle accordion elements
            // if (element.classList.contains('accordion-layer-btn')) {
            // debugLog(element);
            if (element.querySelector('.accordion-layer-btn')) {
                const accordionButton = element.querySelector('.accordion-layer-btn');
                if (accordionButton && accordionButton.classList.contains('collapsed')) {
                    accordionButton.click();
                    console.cclog("[Anchor Scroll Debug] Clicked accordion button to expand");
                }
            }
            
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            console.cclog("[Anchor Scroll Debug] Scrolling to: ", element);
        } else {
            console.cclog("[Anchor Scroll Debug] Element not found for hash: ", window.location.hash);
        }
    } else {
        console.cclog("[Anchor Scroll Debug] No hash found in URL");
    }
}

document.addEventListener("DOMContentLoaded", function() {  

    // Bail if this JS is loaded outside of WordPress
    if (CC_CONSTANTS.isNonWp) {
        console.cclog('[Anchor Scroll Debug] loaded outside of WP, skipping...');
        return;
    }

    console.cclog("[Anchor Scroll Debug] Anchor scroll script loaded");
    
    // Handle initial hash on page load
    handleHashScroll();
    
    // Watch for hash changes (for example works with new custom LP menu)
    window.addEventListener('hashchange', function() {
        console.cclog("[Anchor Scroll Debug] Hash changed to: ", window.location.hash);
        handleHashScroll();
    });
});
